import MainExperience from "./MainExperience/MainExperience";
import { TextGeometry } from "three/addons/geometries/TextGeometry.js";
import { Mesh, MeshStandardMaterial } from "three";

export default class FontMain {
  constructor(
    text,
    size,
    height,
    curveSegments,
    bevelEnabled,
    bevelThickness,
    bevelSize,
    bevelOffset,
    bevelSegments,
    color,
    positionX,
    positionY,
    positionZ,
    rotationX,
    rotationY,
    rotationZ
  ) {
    this.experience = new MainExperience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;

    this.createFont(
      text,
      size,
      height,
      curveSegments,
      bevelEnabled,
      bevelThickness,
      bevelSize,
      bevelOffset,
      bevelSegments,
      color,
      positionX,
      positionY,
      positionZ,
      rotationX,
      rotationY,
      rotationZ
    );
  }

  createFont(
    text,
    size,
    height,
    curveSegments,
    bevelEnabled,
    bevelThickness,
    bevelSize,
    bevelOffset,
    bevelSegments,
    color,
    positionX,
    positionY,
    positionZ,
    rotationX,
    rotationY,
    rotationZ
  ) {
    this.textGeometry = new TextGeometry(text, {
      font: this.resources.items.helvetikerRegularTypeface,
      size: size,
      height: height,
      curveSegments: curveSegments,
      bevelEnabled: bevelEnabled,
      bevelThickness: bevelThickness,
      bevelSize: bevelSize,
      bevelOffset: bevelOffset,
      bevelSegments: bevelSegments,
    });

    this.textGeometry.computeBoundingBox();
    this.textGeometry.center();

    this.text = new Mesh(
      this.textGeometry,
      new MeshStandardMaterial({ color: color })
    );
    this.text.position.set(positionX, positionY, positionZ);
    this.text.rotation.set(rotationX, rotationY, rotationZ);
    this.text.castShadow = true;
    this.scene.add(this.text);
  }
}
